import React, { useState, useEffect, useRef, useCallback } from "react";
import { PowerBIEmbed } from "powerbi-client-react";
import { models } from "powerbi-client";
import axios from "axios";
import { config } from "../constant";
import { axiosAuthHeaderSet } from "helpers/utils";

// core components
import SideBar from "components/SideBar.js";
import AamsHeader from "components/AamsHeader.js";
import Blankpage from "views/blankPage.js";

const embedTokenUrl = config.url.API_URL + "powerbi/embed-token";

function Dashboard() {
  const [embedConfig, setEmbedConfig] = useState(null);
  const [loading, setLoading] = useState(true);
  const [useFallback, setUseFallback] = useState(false);
  const refreshTimerRef = useRef(null);

  const fetchEmbedToken = useCallback(async () => {
    try {
      axiosAuthHeaderSet();
      const resp = await axios.get(embedTokenUrl);
      const data = resp.data.responseData;

      if (!data || !data.embedToken) {
        setUseFallback(true);
        setLoading(false);
        return;
      }

      setEmbedConfig({
        type: "report",
        id: data.reportId,
        embedUrl: data.embedUrl,
        accessToken: data.embedToken,
        tokenType: models.TokenType.Embed,
        settings: {
          layoutType: models.LayoutType.Custom,
          customLayout: {
            displayOption: models.DisplayOption.FitToWidth,
          },
          panes: {
            filters: { expanded: false, visible: false },
          },
          background: models.BackgroundType.Transparent,
        },
      });
      setLoading(false);

      // Schedule token refresh before expiry
      if (refreshTimerRef.current) {
        clearTimeout(refreshTimerRef.current);
      }
      if (data.tokenExpiry) {
        const expiryMs = new Date(data.tokenExpiry).getTime() - Date.now();
        const refreshMs = Math.max(expiryMs - 5 * 60 * 1000, 60 * 1000); // 5 min before expiry, min 1 min
        refreshTimerRef.current = setTimeout(fetchEmbedToken, refreshMs);
      }
    } catch (err) {
      console.error("Failed to get Power BI embed token:", err);
      setUseFallback(true);
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchEmbedToken();
    return () => {
      if (refreshTimerRef.current) {
        clearTimeout(refreshTimerRef.current);
      }
    };
  }, [fetchEmbedToken]);

  if (useFallback) {
    return <Blankpage />;
  }

  return (
    <>
      <SideBar />
      <div id="main_wraper">
        <AamsHeader />

        <div id="dash_board_page" className="pbi-dashboard">
          {loading && (
            <div className="d-flex justify-content-center align-items-center" style={{ height: "calc(100vh - 60px)" }}>
              <span>Loading report...</span>
            </div>
          )}
          {!loading && embedConfig && (
            <PowerBIEmbed
              embedConfig={embedConfig}
              cssClassName="pbi-report"
              getEmbeddedComponent={(embeddedReport) => {
                window.powerBiReport = embeddedReport;
              }}
            />
          )}
        </div>
      </div>
    </>
  );
}

export default Dashboard;
